export default "__VITE_ASSET__CR0AQci4__"